import { render, staticRenderFns } from "./WButton.vue?vue&type=template&id=291b76ce&scoped=true"
import script from "./WButton.vue?vue&type=script&lang=js"
export * from "./WButton.vue?vue&type=script&lang=js"
import style0 from "./WButton.vue?vue&type=style&index=0&id=291b76ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291b76ce",
  null
  
)

export default component.exports